<template>
  <v-container fluid>
    <v-card>
      <PageTitle
        text="Selecionar Módulos"
        class="lead"
      />
      <CycleTimeline
        :show-all="false"
        class="border-bottom"
      />
      <div v-if="phase == 1">
        <div v-if="selectedCycle.count_themes > 0">
          <ModuleStepInstructions />
          <TimelineBlock
            v-for="(block, index) in studyingBlocks.reverse()"
            :key="index"
            :block="block"
          />
          <div class="d-flex justify-center p-4">
            <v-btn
              color="nitro"
              class="my-2 my-sm-0 white--text"
              @click="phase = 2"
            >
              CONTINUAR CONTEÚDO
              <v-icon>
                fa fa-arrow-circle-right ml-2 text-sm
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div v-else>
          <SelectBlocksInstructions />
          <TrailBlockSelection
            v-if="(phase == 1 && selectedCycle.count_themes == 0 && !selectedCycleHasModules) || selectedCycle.order == 5 && phase == 1"
            @onCancel="onCancel"
            @onConfirm="phase = 2"
          />
        </div>
      </div>
      <div v-else>
        <SelectModuleInstructions />
        <ModuleBlockSelection @onCancel="phase = 1" />
      </div>
    </v-card>
  </v-container>
</template>
<script>


import SelectModuleInstructions from '@/student/pages/module/components/SelectModuleInstructions'
import SelectBlocksInstructions from '@/student/pages/module/components/SelectBlocksInstructions'
import PageTitle from '@/common/components/PageTitle'
import {  mapActions, mapGetters, mapMutations } from 'vuex'
import { studyNowRouteName, homeRouteName } from '@/student/constants/routes'
import {DEFAULT_MODAL_OPACITY} from "@/student/constants/general.js"
import CycleTimeline from "@/common/components/CycleTimeline";
import TrailBlockSelection from '@/student/pages/module/components/TrailBlockSelection'
import ModuleBlockSelection from '@/student/pages/module/components/ModuleBlockSelection'
import ModuleStepInstructions from './components/ModuleStepInstructions'
import TimelineBlock from './components/TimelineBlock'

export default {
  components: {
    SelectModuleInstructions,
    SelectBlocksInstructions,
    ModuleBlockSelection,
    PageTitle,
    CycleTimeline,
    TrailBlockSelection,
    ModuleStepInstructions,
    TimelineBlock,
},
  data() {
    return {
      showModal: false,
      homeRouteName,
      DEFAULT_MODAL_OPACITY,
      studyNowRouteName,
      phase: 1,
    }
  },
  computed: {
    ...mapGetters(['trails', 'current_cycle', 'selectedCycle', 'selectedCycleHasModules', 'studyingThemes', 'authUser', 'current_cycle', 'studyingBlocks']),
    showTimeline(){
      return this.phase == 1
    },
  },
  watch:{
    selectedCycle:{
      handler(){
        this.$router.push({ name: studyNowRouteName })
      },
      immediate: false,
      deep: true,
    }
  },
  created(){
    if(this.selectedCycle.is_finished && !this.selectedCycle.released){
      this.$router.push({name: studyNowRouteName})
    }
  },
  methods: {
    ...mapMutations(['SET_CYCLE']),
    onCancel(){
      this.SET_CYCLE(this.current_cycle)
      this.$router.push({name: studyNowRouteName})
    },
  }
}
</script>
